export const isResetAutoplayEnabledStorageKey =
    'THRIVEGLOBAL_IS_RESET_AUTOPLAY_ENABLED'
export const isResetAutoplayEnabledDefaultValue = true
